<template>
  <!-- [matrah] Tiny inline-SVG flags (emoji flags render as letters on Windows). -->
  <span class="lang-flag" :title="meta.name" :style="{ width: size + 'px', height: Math.round(size * 0.7) + 'px' }">
    <svg v-if="meta.flag === 'om'" viewBox="0 0 30 21" preserveAspectRatio="none">
      <rect width="30" height="21" fill="#fff" />
      <rect y="7" width="30" height="7" fill="#DB161B" />
      <rect y="14" width="30" height="7" fill="#008000" />
      <rect width="8" height="21" fill="#DB161B" />
    </svg>
    <svg v-else-if="meta.flag === 'gb'" viewBox="0 0 30 21" preserveAspectRatio="none">
      <rect width="30" height="21" fill="#012169" />
      <path d="M0 0L30 21M30 0L0 21" stroke="#fff" stroke-width="4" />
      <path d="M0 0L30 21M30 0L0 21" stroke="#C8102E" stroke-width="1.6" />
      <path d="M15 0V21M0 10.5H30" stroke="#fff" stroke-width="6" />
      <path d="M15 0V21M0 10.5H30" stroke="#C8102E" stroke-width="3.2" />
    </svg>
    <svg v-else-if="meta.flag === 'pk'" viewBox="0 0 30 21" preserveAspectRatio="none">
      <rect width="30" height="21" fill="#01411C" />
      <rect width="8" height="21" fill="#fff" />
      <circle cx="19" cy="10.5" r="5.5" fill="#fff" />
      <circle cx="20.8" cy="9.4" r="5" fill="#01411C" />
      <polygon points="23.5,5 24.1,6.8 26,6.8 24.5,7.9 25.1,9.7 23.5,8.6 21.9,9.7 22.5,7.9 21,6.8 22.9,6.8" fill="#fff" />
    </svg>
    <svg v-else-if="meta.flag === 'bd'" viewBox="0 0 30 21" preserveAspectRatio="none">
      <rect width="30" height="21" fill="#006A4E" />
      <circle cx="13.5" cy="10.5" r="6" fill="#F42A41" />
    </svg>
    <svg v-else-if="meta.flag === 'in'" viewBox="0 0 30 21" preserveAspectRatio="none">
      <rect width="30" height="7" fill="#FF9933" />
      <rect y="7" width="30" height="7" fill="#fff" />
      <rect y="14" width="30" height="7" fill="#138808" />
      <circle cx="15" cy="10.5" r="2.6" fill="none" stroke="#000080" stroke-width="0.8" />
      <circle cx="15" cy="10.5" r="0.5" fill="#000080" />
    </svg>
    <svg v-else viewBox="0 0 30 21" preserveAspectRatio="none">
      <rect width="30" height="21" fill="#B0BEC5" />
      <text x="15" y="15" font-size="11" text-anchor="middle" fill="#37474F" font-family="sans-serif">?</text>
    </svg>
  </span>
</template>

<script>
import { languageMeta } from '@/utils/templateLanguages'

export default {
  name: 'LanguageFlag',
  props: {
    code: { type: String, required: true },
    size: { type: Number, default: 20 },
  },
  computed: {
    meta() {
      return languageMeta(this.code)
    },
  },
}
</script>

<style scoped>
.lang-flag {
  display: inline-block;
  vertical-align: middle;
  border-radius: 2px;
  overflow: hidden;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12);
  flex: 0 0 auto;
}

.lang-flag svg {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
